import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeatureFlag } from './feature-flag.models';
import { AuthStore } from '../../core/auth';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private readonly apiUrl = '/api/v1/feature-flags';
  private readonly authStore = inject(AuthStore);

  constructor(private http: HttpClient) {}

  listFeatureFlags(): Observable<FeatureFlag[]> {
    return this.http.get<FeatureFlag[]>(this.apiUrl);
  }

  toggleFeatureFlag(key: string, enabled: boolean): Observable<FeatureFlag> {
    return this.http.patch<FeatureFlag>(`${this.apiUrl}/${key}`, { enabled });
  }

  isEnabled(key: string): boolean {
    const features = this.authStore.actor()?.features;
    return features?.[key] ?? false;
  }
}